import request from './request'

// 机构分页列表
export function getCarInstitutionList(data) {
	return request.fetch('carInstitution', data)
}

// 新增机构
export function addCarInstitution(data) {
	data["json"] = true;
	return request.post('carInstitution/add', data)
}

// 编辑机构
export function updateCarInstitution(data) {
	data["json"] = true;
	return request.put('carInstitution', data)
}

// 切换AI证件核对开关
export function updateCarInstitutionAiCheck(data) {
	data["json"] = true;
	return request.put('carInstitution/aiCheck', data)
}

// 切换手动分派开关
export function updateCarInstitutionManualDispatch(data) {
	data["json"] = true;
	return request.put('carInstitution/manualDispatch', data)
}

// 根据id获取机构
export function getCarInstitution(id) {
	return request.fetch('carInstitution/' + id)
}

// 删除机构
export function delCarInstitution(id) {
	return request.delete('carInstitution/' + id)
}
